<template>
   <SecondMenu />
</template>
<script>
  import SecondMenu from '../index/SecondMenu'

  export default {
    data() {
      return {
      }
    },
    mounted() {
      if (JSON.parse(localStorage.getItem("hpapi_userInfoModel")).tenantid != 'd6d0f500-6c34-45e6-b206-b87c368e4469') {
        this.$router.push("/login");
      }
    },
    components: {
      "SecondMenu": SecondMenu
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/set/sys.vue